import Hearty from './components/Hearty';

export default function App() {
  return (
    <>
    <h1 style={{ textAlign: "center" }}>Hearty</h1>
    <Hearty />
    </>
  );
}